import React from 'react'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Example from '../Rules/Rules';
import Accordion from 'react-bootstrap/Accordion';

export default function HelpMinecraft() {
    return (
        <div>
            <div className='c_c'>
                <Image className='Tr_block_img' src='https://i.pinimg.com/originals/de/ba/04/deba0494de3491fd418e02185cc96d19.jpg'></Image>
            </div>

            <div className='All_block_one'>
                <p className='All_text_block_one'>Играй с нами в Minecraft , на нашем сервере!. <br />
                    IP сервера: <u> d2.gamely.pro:27001 </u><br />
                    <br />
                    Для игры необходимо скачать Java и TLauncher, версия сервера: <u>1.17.1 </u></p>
            </div>

            <div className='HelpMinecraft_block'>
                <Button className='HelpMinecraft_button' href='https://tlauncher.org/' target='_blank' variant="dark">TLauncher</Button>
                <Button className='HelpMinecraft_button' href='https://www.java.com/ru/download/manual.jsp' target='_blank' variant="dark">Java</Button>
            </div>

            <div className='Tr_stick'></div>

            <div className='Dysplay_none noner'>
                <h1 className='HelpMinecraft_center'>Голосуй за нас!</h1>
                <div className='HelpDontStarveTogether'>
                    <Image className='Tr_block_img_img' src='https://avatars.dzeninfra.ru/get-zen_doc/1570751/pub_5e0f5ebd0a451800acb4770a_5e1228505fd55f00ae37f44c/scale_1200'>
                    </Image>

                    <div className='HelpDontStarveTogether_block'>
                        <Button className='HelpMinecraft_block_button' href='https://mc-monitor.org/server/15797' target='_blank' variant="dark">Голосуй за нас на MC</Button>
                        <Button className='HelpMinecraft_block_button' href='https://topcraft.ru/servers/11859/' target='_blank' variant="dark">Голосуй за нас на Top</Button>
                        <Example></Example>
                    </div>
                </div>
                <div className='Tr_stick'></div>
                <Accordion className='Accordion' >
                    <Accordion.Item eventKey="0">
                        <Accordion.Header >Команды сервера ClanWar</Accordion.Header>
                        <Accordion.Body>
                            <ListGroup>
                                <h1 className='HelpMinecraft_center'>Клановые команды</h1>
                                <ListGroup.Item variant="info">
                                    /clan create "название пароль" - Создайте клан с паролем.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan join "название клана" - Присоединяйтесь к открытому клану.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan join "название" "пароль" - Присоединяйтесь к клану, используя пароль.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan color "выберете цвет из списка" - Измените цвет названия клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan nickname "псевдоним" - Дайте себе прозвище для кланового чата.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan nickname "empty" - Сбрось прозвище своего клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan passowner "ник игрока" - Передать право собственности на клан другому игроку.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan promote "ник игрока" - Повысить игрока до более высокого статуса клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan password "пароль" - Изменить свой пароль от клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan request "ник игрока" - Пингануть игрока, чтобы присоединиться к вашему клану.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan block "ник игрока" - Заблокировать игрока от приглашения.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan claim - Захватить территорию ( чанк ), в котором вы стоите.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan unclaim - Удалить территорию, на которой вы стоите.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan unclaim all - Удалить все территории.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan info - Просмотр информации о вашем клане
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan list - Посмотреть список всех кланов.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan chat - Переключение между клановыми / союзными / глобальными каналами чата.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan setbase - Установить спавн базы клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan demote "ник игрока" - Понизить титул игрока в клане.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan ally "add или remove" "название клана" - Добавить или удалить другой клан в союз.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan enemy "add или remove" "название клана" - Добавить или удалить другой клан во вражду.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan kick "ник игрока" - Выгони игрока из своего клана.
                                </ListGroup.Item>
                                <ListGroup.Item variant="info">
                                    /clan leave - Ливнуть с клана.
                                </ListGroup.Item>
                            </ListGroup>

                            <ListGroup>
                                <h1 className='HelpMinecraft_center'>Команды сервера</h1>
                                <ListGroup.Item variant="success">
                                    /msg ; /tell ; /m ; /whisper - Отправить личное сообщение
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /delhome название дома - Удалить точку home
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /sethome название дома без пробелов - Установить точку дома
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /home - телепортироваться домой
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /tpa ник игрока- телепортироваться к игроку
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /tpaccept - принять запрос на телепортацию
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /tpdeny - отменить запрос на телепортацию
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /warp название - телепортироваться в указанное место
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /helpop - список команд
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /balance - проверить баланс
                                </ListGroup.Item>
                                <ListGroup.Item variant="success">
                                    /spawn - телепортироваться на spawn
                                </ListGroup.Item>
                            </ListGroup>

                            <ListGroup>
                                <h1 className='HelpMinecraft_center'>Команды VIP статуса</h1>
                                <ListGroup.Item variant="warning">
                                    Красивый прёфикс VIP
                                </ListGroup.Item>
                                <ListGroup.Item variant="warning">
                                    /enderchest - открывает эндер сундук где бы вы ни были
                                </ListGroup.Item>
                                <ListGroup.Item variant="warning">
                                    /workbench - открывает верстак где бы вы ни были
                                </ListGroup.Item>
                                <ListGroup.Item variant="warning">
                                    /kits vip - дает дополнительные ресурсы
                                </ListGroup.Item>
                                <ListGroup.Item variant="warning">
                                    /clear - очистка инвентаря
                                </ListGroup.Item>
                                <ListGroup.Item variant="warning">
                                    /sethome home123 - возможности создать 3 точки дома
                                </ListGroup.Item>
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Киты сервера ClanWar</Accordion.Header>
                        <Accordion.Body>
                            <ListGroup>
                                <h1 className='HelpMinecraft_center'>Статус Игрок</h1>
                                <p className='HelpMinecraft_center_text'>Эта роль выдается автоматически, когда вы первый раз зашли на сервер.</p>
                                <ListGroup.Item variant="info" className='ListGroupItem'> Доступен / kits start который можно использовать 1 раз в 12 часов
                                    <img src="https://media.discordapp.net/attachments/1062187510089908255/1064741201372266496/image.png" alt="" />
                                </ListGroup.Item>
                                <p className='HelpMinecraft_center_text'>Vip статус стоит 250 рублей в месяц</p>
                                <ListGroup.Item variant="info" className='ListGroupItem'> Доступен / kits vip который можно использовать 1 раз в 24 часа
                                    <img src="https://media.discordapp.net/attachments/1062187510089908255/1064737393841815662/image.png" alt="" />
                                </ListGroup.Item>
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </div>
    )
}